export const profilePointsPageStyles = {
  page: {
    paddingBottom: 24,
  } as const,
  heroCard: {
    margin: '12px 14px 14px',
    borderRadius: 22,
    padding: '18px 16px',
    color: '#ffffff',
    background: 'linear-gradient(135deg, #5f66f2 0%, #756df4 54%, #8b67ed 100%)',
    boxShadow: '0 14px 30px rgba(112, 103, 239, 0.24)',
  } as const,
  heroLabel: {
    fontSize: 13,
    lineHeight: 1.4,
    color: 'rgba(255,255,255,0.78)',
    fontWeight: 700,
  } as const,
  heroValue: {
    marginTop: 8,
    fontSize: 36,
    lineHeight: 1,
    fontWeight: 900,
  } as const,
  heroHint: {
    marginTop: 10,
    fontSize: 12,
    lineHeight: 1.45,
    color: 'rgba(255,255,255,0.78)',
    fontWeight: 600,
  } as const,
  listWrap: {
    margin: '0 14px',
    borderRadius: 18,
    overflow: 'hidden',
    background: '#ffffff',
    boxShadow: '0 10px 24px rgba(31, 35, 41, 0.06)',
  } as const,
  rowMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  } as const,
  dateText: {
    fontSize: 15,
    lineHeight: 1.35,
    color: '#1f2430',
    fontWeight: 800,
  } as const,
  countText: {
    marginTop: 3,
    fontSize: 12,
    lineHeight: 1.35,
    color: '#8a92a3',
    fontWeight: 600,
  } as const,
  pointText: {
    fontSize: 18,
    lineHeight: 1.2,
    color: '#16a34a',
    fontWeight: 900,
    whiteSpace: 'nowrap',
  } as const,
  sourceList: {
    marginTop: 10,
    paddingTop: 9,
    borderTop: '1px solid rgba(31,35,41,0.06)',
    display: 'grid',
    gap: 6,
  } as const,
  sourceRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    fontSize: 12,
    lineHeight: 1.4,
    color: '#6c7383',
  } as const,
  sourcePoints: {
    color: '#1f2430',
    fontWeight: 800,
    whiteSpace: 'nowrap',
  } as const,
};
